/** @module lib/plan_data/itemSelectors
 *
 * @desc
 * Memoized Redux selectors for state.items derivations. The Immutable +items+
 * list is treated as immutable-by-reference: when its identity changes we recompute,
 * otherwise we return the same array so connected components don't see a new
 * reference (which would otherwise defeat react-redux's shallow-prop equality
 * check and force re-renders on every store update).
 */
import {List} from 'immutable'

let cachedItems
let cachedAllItemIds = []

/**
 * Returns a stable plain-JS array of all metadata item ids, recomputed only
 * when +state.items+ is replaced (by reference). Safe to use directly in
 * +mapStateToProps+ for class-based +connect()+ wrappers.
 */
export const selectAllItemIds = state => {
  const items = state.items
  if (items === cachedItems) return cachedAllItemIds

  cachedItems = items
  cachedAllItemIds = (items || List()).map(item => item.get('id')).toArray()
  return cachedAllItemIds
}
